export var RELATIVE_TAB = 'relative';
export var ABSOLUTE_TAB = 'absolute';
export var DEFAULT_TIMEFRAME = 'this_14_days';